import { createContext, ReactNode, useContext, useMemo } from 'react'

interface Content {
  placeId?: string
  type?: string
  id?: string
  visitId?: string
  reviewId?: string
  businessId?: string
}

const ContentContext = createContext<Content>({})

interface Props extends Content {
  children?: ReactNode
}

export const ContentProvider = ({ id, type, children, placeId, reviewId, visitId, businessId }: Props) => {
  const content = useMemo<Content>(
    () => ({ id, type, placeId, reviewId, visitId, businessId }),
    [id, type, placeId, reviewId, visitId, businessId],
  )

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>
}

export const useContent = () => useContext(ContentContext)
